import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpResponse} from '@angular/common/http';
import {Constants} from '../shared/Helpers/constants';
import {Observable} from 'rxjs';
import { environment } from '@env/environment';
import { IEnable2FAMethod, ISmsAuthenticatorPatch, IUser2FAConfigurationPost } from '../shared/interfaces';

@Injectable()
export class TwoFAService {
  private headers: HttpHeaders;
  private host = environment.idam_api_url;

  constructor(private _http: HttpClient) {

  }

  getQRCode(organisationId: string, userId: string, code: string): Observable<HttpResponse<any>> {
    this.headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
      'Content-Type': 'application/json',
      'X-Tenant-ID': 'tenant1'
    });

    let url = `${this.host}/api/v1/2fa/organisation/${organisationId}/user/${userId}/qr-code`;
    if (code != null) {
      url += `?code=${code}`;
    }
    return this._http.get(url, {observe: 'response', headers: this.headers, responseType: 'text'});
  }

  getUser2FAConfiguration(organisationId: string, userId: string):  Observable<HttpResponse<any>> {
    this.headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
      'Content-Type': 'application/json',
      'X-Tenant-ID': 'tenant1'
    })
    const url = `${this.host}/api/v1/2fa/organisation/${organisationId}/user/${userId}/2factor-authentication`;
    return this._http.get(url, {observe: 'response', headers: this.headers});
  }

  switch2FAMethodEnabled(organisationId: string, userId: string, enableMethodDTO: IEnable2FAMethod): Observable<HttpResponse<any>> {
    const token: any = JSON.parse(localStorage.getItem(Constants.localStorage_currentUser))?.token;
    this.headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    })
    const url = `${this.host}/api/v1/2fa/organisation/${organisationId}/user/${userId}/2factor-authentication`;
    return this._http.patch(url, enableMethodDTO, {observe: 'response', headers: this.headers});
  }


  resend2FACode(organisationId: string, userId: string, type: string):  Observable<HttpResponse<any>> {
    const token: any = JSON.parse(localStorage.getItem(Constants.localStorage_currentUser))?.token;
    this.headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    })
    const url = `${this.host}/api/v1/2fa/organisation/${organisationId}/user/${userId}/2factor-authentication/resend?type=${type}`;
    return this._http.post(url, {}, {observe: 'response', headers: this.headers});
  }

  confirmDevice(organisationId: string, userId: string, confirmationNumber: string):  Observable<HttpResponse<any>> {
    const token: any = JSON.parse(localStorage.getItem(Constants.localStorage_currentUser))?.token;
    this.headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    })
    const url = `${this.host}/api/v1/2fa/organisation/${organisationId}/user/${userId}/2factor-authentication/app-confirm?confirmationNumber=${confirmationNumber}`;
    return this._http.get(url, {observe: 'response', headers: this.headers});
  }

  changeSmsConfiguration(organisationId: string, userId: string, twoFactorConfigId: string, smsAuthenticatorDto: ISmsAuthenticatorPatch):  Observable<HttpResponse<any>> {
    const token: any = JSON.parse(localStorage.getItem(Constants.localStorage_currentUser))?.token;
    this.headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    })
    const url = `${this.host}/api/v1/2fa/organisation/${organisationId}/user/${userId}/2factor-authentication/${twoFactorConfigId}/sms`;
    return this._http.patch(url, smsAuthenticatorDto, {observe: 'response', headers: this.headers});
  }

  setupUser2FAConfiguration(organisationId: string, userId: string, user2FAConfigurationDto: IUser2FAConfigurationPost):  Observable<HttpResponse<any>> {
    const token: any = JSON.parse(localStorage.getItem(Constants.localStorage_currentUser))?.token;
    this.headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    })
    const url = `${this.host}/api/v1/2fa/organisation/${organisationId}/user/${userId}/2factor-authentication`;
    return this._http.post(url, user2FAConfigurationDto, {observe: 'response', headers: this.headers});
  }

  confirmDeviceChange(secretKey: string, allow: boolean, tenantId: string):  Observable<HttpResponse<any>>{
    this.headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
      'Content-Type': 'application/json'
    });
    const url = `${this.host}/api/v1/2fa/confirmation?secret=${secretKey}&allow=${allow}&tenant=${tenantId}`;
    return this._http.get(url, {observe: 'response', headers: this.headers});
  }
}
